const styles: StyleObject = {
  container: {
    display: 'flex',
    justifyContent: 'center',
  },

  markdown: {
    variant: 'text.medium',
    color: 'textLight',
  },

  bold: {
    color: 'primary',
  }
  ,
}

export default styles
